import css from '@emotion/css';
import { default as React, useContext } from 'react';
import { Trans } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { useSaveTemplate } from '../../../hooks';
import { templatesContext } from '../../../state';
import { updateHintPreferences } from '../../../state/hint-preferences/hint-preferences.atom';
import { closeLocationChangedHint, useOpenedLocationChangedHint } from '../../../state/opened-location-changed.atom';
import { IconReady } from '../../gologin-header/icons/icon-ready';
import GologinPopover from '../../gologin-popover';
import NotificationTooltip from '../notification-card';

const LocationChangedHint: React.FC = () => {
  const { isOpen: isHintOpened, anchorEl, profileId } = useOpenedLocationChangedHint();
  const history = useHistory();
  const { selectedTemplate, updateSelectedTemplate } = useContext(templatesContext);
  const { saveTemplate } = useSaveTemplate(selectedTemplate, updateSelectedTemplate);
 
  const isLocationChangedHintVisible = isHintOpened;

  const handleDontAddProxy = async () => {
    updateHintPreferences({ locationChanged: 'hidden' });
    closeLocationChangedHint();
    await saveTemplate({
      proxy: {
        quickProfileCreate: 'no-proxy',
      },
    });
  };

  const handleClose = () => {
    updateHintPreferences({ locationChanged: 'hidden' });
    closeLocationChangedHint();
  };

  const handleDefaultSettingsClick = () => {
    closeLocationChangedHint();
    history.push('/personalArea/default-profile-settings');
  };

  if (!isLocationChangedHintVisible) {
    return null;
  }

  return (
    <GologinPopover
      anchorEl={anchorEl}
      trigger='click'
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      width={300}
      popoverStyle={css`
        padding: 0;
        overflow: visible;
        gap: 0;
      `}
      extraTranslate={{ top: 42 }}
      zIndex={1100}
      onClose={handleClose}
    >
      <NotificationTooltip
        title={<Trans i18nKey='profileTable.hints.locationChanged.title'>Location changed</Trans>}
        description={
          <Trans i18nKey='profileTable.hints.locationChanged.description'>
            We added a proxy to make your connection safer. You can change this later in{' '}
            <span
              style={{ textAlign: 'left', textDecoration: 'underline', cursor: 'pointer' }}
              onClick={handleDefaultSettingsClick}
            >
              Default Settings
            </span>
            .
          </Trans>
        }
        AdditionalIconBeforeTitle={<IconReady padding={0} iconColor='var(--00A987)'></IconReady>}
        secondaryButton={
          <span style={{ textAlign: 'left' }}>
            <Trans i18nKey='profileTable.hints.locationChanged.dontAddProxy'>Don’t add proxy automatically</Trans>
          </span>
        }
        onSecondaryButtonClick={handleDontAddProxy}
        handleClose={handleClose}
      />
    </GologinPopover>
  );
};

export default LocationChangedHint;
